import React from 'react';
import { useTranslation } from 'react-i18next';
import { GovSkeleton } from '@gov-design-system-ce/react';
import { LocalizeNameSpaceTypes } from '@gov-nx/core/service';
import { LayoutGap } from '@gov-nx/ui/web';

export const ProfilROSSkeleton = () => {
	const { t: tg } = useTranslation(LocalizeNameSpaceTypes.Global);
	return (
		<LayoutGap gap="m">
			<div>
				<GovSkeleton
					width="90%"
					height="21px"
					aria-label={tg('loading.wcag.processing', {
						namespace: LocalizeNameSpaceTypes.Global,
					})}
				/>
				<GovSkeleton
					width="100%"
					height="21px"
					aria-label={tg('loading.wcag.processing', {
						namespace: LocalizeNameSpaceTypes.Global,
					})}
				/>
				<GovSkeleton
					width="60%"
					height="21px"
					aria-label={tg('loading.wcag.processing', {
						namespace: LocalizeNameSpaceTypes.Global,
					})}
				/>
			</div>
			<GovSkeleton
				width="270px"
				height="24px"
				aria-label={tg('loading.wcag.processing', {
					namespace: LocalizeNameSpaceTypes.Global,
				})}
			/>
			{Array.from({ length: 2 }).map((_) => (
				<LayoutGap
					gap="m"
					className="p-6">
					<GovSkeleton
						width="220px"
						height="24px"
						aria-label={tg('loading.wcag.processing', {
							namespace: LocalizeNameSpaceTypes.Global,
						})}
					/>
					<div className="flex flex-col items-start gap-4 [ sm:flex-row sm:items-center ]">
						<div className="flex gap-1">
							<GovSkeleton
								width="30px"
								height="20px"
								aria-label={tg('loading.wcag.processing')}
							/>
							<GovSkeleton
								width="90px"
								height="20px"
								aria-label={tg('loading.wcag.processing')}
							/>
							<GovSkeleton
								width="20px"
								height="20px"
								aria-label={tg('loading.wcag.processing')}
								className="ml-4!"
							/>
						</div>
						<div className="flex gap-1">
							<GovSkeleton
								width="40px"
								height="20px"
								aria-label={tg('loading.wcag.processing')}
							/>
							<GovSkeleton
								width="250px"
								height="20px"
								aria-label={tg('loading.wcag.processing')}
							/>
						</div>
					</div>
				</LayoutGap>
			))}
		</LayoutGap>
	);
};
